// extracted by mini-css-extract-plugin
export default {"scroll_to_wrapper":"ScrollToSection_scroll_to_wrapper__Emcgh"};